// store.js
import { configureStore } from '@reduxjs/toolkit';
import tokenReducer from './reducers/tokenReducer';
import userReducer from './reducers/userReducer';
import groupSitesReducer from './reducers/groupSitesReducer';
import groupsReducer from './reducers/groupsReducer';
import updateDataReducer from './reducers/updateDataReducer';
import confirmationPopupReducer from './reducers/confirmationPopupReducer';
import completedSitesLoading from './reducers/completedSitesLoadingReducer';
import updateLocationReducer from './reducers/updateLocationReducer';
import allSitesLoadedReducer from './reducers/allSitesLoadedReducer';
import heartbeatReducer from './reducers/heartbeatReducer';

const store = configureStore({
	reducer: {
		tokens: tokenReducer, // Make sure to provide your actual reducer name here
		user: userReducer,
		groupSites: groupSitesReducer,
		groups: groupsReducer,
		updateReduxData: updateDataReducer,
		confirmationPopup: confirmationPopupReducer,
		completedSitesLoading: completedSitesLoading,
    	updateLocation: updateLocationReducer,
		allSitesLoaded: allSitesLoadedReducer,
		heartbeat: heartbeatReducer,
	},
});

export default store;
